import { IconModify } from "../../../../../../utils/icon-table.modify"
import { recStatusModify } from "../../../../../../utils/rec-status.modify"

export const modifyInformationFeriados = async (dados: any) => {
    await dados.forEach((value: any) => {
      value.hdayRecStatus = recStatusModify.table(value.hdayRecStatus) 
      value.hdayPermanente = IconModify.toTable(value.hdayPermanente)
    })}